// extracted by mini-css-extract-plugin
export default {"Root":"slider_Root__GjP2l","Container":"slider_Container__nRZrB","Slide":"slider_Slide__K3Vv-"};